export default __webpack_public_path__ + "static/icon-dropdown-about-fcd879cde91ed20cbcaff6569d63547c.svg";